import { apiMap } from "./ApiConfig"

const mapApi = {
    searchLocation: (q: string) => {
        return apiMap.get(`/search?q=${q}&format=json&addressdetails=1&limit=10`)
    },
    detectAddress: (lat: number, long: number) => {
        return apiMap.get(`/reverse?format=json&lat=${lat}&lon=${long}`)
    },
    detectZipCode: (lat: number, long: number) => {
        return apiMap.get(`/v1/postcode/search?lat=${lat}&lon=${long}&apiKey=${process.env.REACT_APP_GEOAPIFY_KEY}`, {
            baseURL: process.env.REACT_APP_GEOAPIFY_MAP_API
        })
    },
    mapRouting: ([lat1, lon1]: any[], [lat2, lon2]: any[]) => {
        return apiMap.get(`/v1/routing?waypoints=${lat1},${lon1}|${lat2},${lon2}&mode=truck&apiKey=${process.env.REACT_APP_GEOAPIFY_KEY}`, {
            baseURL: process.env.REACT_APP_GEOAPIFY_MAP_API
        })
    }
}

export default mapApi;
